import { getCandidatesByZohoIds } from './candidates';

export const ZOHO_UPDATE_LIST_URL =
  'https://n8n.hireportal.ai/webhook/zoho_update_list';

const normalizeZohoIdList = (ids) => (
  (Array.isArray(ids) ? ids : [])
    .map((id) => String(id ?? '').trim())
    .filter(Boolean)
);

const resolveZohoCandidates = (zohoIds, byZohoId) => (
  zohoIds.map((zohoId) => {
    const match = byZohoId.get(zohoId);
    return match || { id: null, fullName: null, zohoId };
  })
);

/**
 * Upload selected Zoho candidates via n8n webhook.
 * Body: { user_id, zoho_ids: string[] }
 */
export const uploadCandidatesToZohoList = async (userId, zohoIds = []) => {
  const ids = normalizeZohoIdList(zohoIds);
  if (!userId) {
    throw new Error('Missing user id');
  }
  if (ids.length === 0) {
    throw new Error('No Zoho candidates to upload');
  }

  const response = await fetch(ZOHO_UPDATE_LIST_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user_id: userId,
      zoho_ids: ids,
    }),
  });

  if (response.status < 200 || response.status >= 300) {
    const error = new Error(`Upload failed (status ${response.status}).`);
    error.status = response.status;
    throw error;
  }

  let data = null;
  try {
    data = await response.json();
  } catch {
    // Empty or non-JSON body.
  }

  const skippedIds = normalizeZohoIdList(data?.skipped_ids);
  const failedIds = normalizeZohoIdList(data?.failed_ids);
  let skippedCandidates = [];
  let failedCandidates = [];

  if (skippedIds.length > 0 || failedIds.length > 0) {
    try {
      const byZohoId = await getCandidatesByZohoIds(userId, [...skippedIds, ...failedIds]);
      skippedCandidates = resolveZohoCandidates(skippedIds, byZohoId);
      failedCandidates = resolveZohoCandidates(failedIds, byZohoId);
    } catch (lookupErr) {
      console.error('Failed to resolve Zoho candidate ids:', lookupErr);
      skippedCandidates = resolveZohoCandidates(skippedIds, new Map());
      failedCandidates = resolveZohoCandidates(failedIds, new Map());
    }
  }

  return {
    total: Number(data?.total ?? ids.length),
    updated: Number(data?.updated ?? data?.added ?? 0),
    skipped: Number(data?.skipped ?? skippedIds.length),
    failed: Number(data?.failed ?? failedIds.length),
    skippedCandidates,
    failedCandidates,
  };
};
